"use strict";
// do NOT remove this file - it would break pre-compiled schemas
// https://github.com/ajv-validator/ajv/issues/889
module.exports = require("fast-deep-equal");
//# sourceMappingURL=equal.js.map